import React from 'react';
import PropTypes from 'prop-types';

const InputFeedback = ({ error }) =>
  (error ? <p className="input-feedback help is-danger">{error}</p> : null);

InputFeedback.propTypes = {
  error: PropTypes.string,
};

InputFeedback.defaultProps = {
  error: null,
};

export default InputFeedback;



// WEBPACK FOOTER //
// ./src/components/common/form/InputFeedback.jsx